import { useQuery } from 'react-query';
import { trackPromise } from 'react-promise-tracker';
import { getAllChains, getChain } from '../index';
export const useGetAllChains = (additionlInfo) => useQuery(['GetIntegrationChainDescriptionList', additionlInfo], () => trackPromise(getAllChains(additionlInfo)), {
    cacheTime: 0
});
export const useGetChain = (additionlInfo) => useQuery(['GetIntegrationChainByGuid', additionlInfo], () => trackPromise(getChain(additionlInfo)), {
    cacheTime: 0
});
